import Helper from "./Helper";

class VideScrollSection {
  constructor(config = {}) {
    const {
      videoSectionSelector,
      videoFrameSelector
    } = config;

    this.videoSectionSelector = videoSectionSelector || ".ns-video-section";
    this.videoFrameSelector = videoFrameSelector || ".ns-video-section__frame";

    this.videoSections = Array.prototype.slice.call(
      document.querySelectorAll(this.videoSectionSelector)
    );

    this.scrollSpeed = 60; // after X pixel scrolling frame will be replaced

    this.videoSections.forEach((section, index) => {
      this.registerScroll(section, index);
    });

    // remove placeholders so they don't interfere with spacing
    this.placeholders = Array.prototype.slice.call(document.querySelectorAll('.video-section-placeholder'));
    this.placeholders.forEach(placeholder => {
      placeholder.remove();
    });

    this.spinner = document.querySelector('.spinner-container');
    if (this.spinner) {
      Helper.addClass(document.querySelector('body'), 'spinner-visible');
    }

    window.addEventListener("resize", () => {
      this.videoSections.forEach((section) => {
        section.style.height = window.innerHeight - document.querySelector('.header').offsetHeight;
      });
    });

    window.addEventListener('load', () => {
      if (this.spinner) {
        Helper.fadeOut(this.spinner);
        Helper.removeClass(document.querySelector('body'), 'spinner-visible');
        this.videoSections.forEach((section) => {
          section.style.height = window.innerHeight - document.querySelector('.header').offsetHeight;
        });
      }
    });
  }

  registerScroll(section, index) {
    const hh = document.querySelector(".header").offsetHeight;
    const vh = window.innerHeight;

    const frames = Array.prototype.slice.call(section.querySelectorAll(this.videoFrameSelector));
    const parent = section.parentElement;
    const frameTotal = frames.length;
    const pOff = Helper.offset(parent).top;

    let currentFrame = 0;
    let lastFrame = 0;
    let scrollIncrement = this.scrollSpeed; // initial val, will be increased during scroll
    let lastScrollTop = window.pageYOffset;

    let sectionHeight = frameTotal * this.scrollSpeed + hh + vh;
    parent.style.height = sectionHeight + "px";

    const aniStartPos = pOff - hh;
    const aniEndPos = frameTotal * this.scrollSpeed + aniStartPos;

    window.addEventListener("scroll", () => {
      let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let insideScrollPos = currentScrollTop - aniStartPos;
      const frame = Math.floor(insideScrollPos / this.scrollSpeed);

      if (aniStartPos < currentScrollTop && currentScrollTop < aniEndPos) {
        // console.log("inside section!!!");

        currentFrame = frame;
        var frameList = [];
        if (currentFrame < lastFrame) {
          for (var i = currentFrame; i <= lastFrame; i++) {
            frameList.push(i);
          }
        } else {
          for (var i = lastFrame; i <= currentFrame; i++) {
            frameList.push(i);
          }
        }

        // lazyloading the next x frames from current Frame
        frames.forEach((frame, index) => {
          if (index < currentFrame + 20) {
            const img = frame.getAttribute('data-bg-img');
            frame.style.backgroundImage = `url(${img})`;
          }
        });

        lastFrame = frame;

        frameList.forEach((frameIndex) => {
          frames.forEach((frame, index) => {
            if (index == frameIndex) {
              frame.style.opacity = 1;
              frame.style.zIndex = 2;
            } else {
              frame.style.opacity = 0;
              frame.style.zIndex = 1;
            }
          });
        });
      } else {
        // outside of scrolling section
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    });
  }
}

export default VideScrollSection;
